import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css } from "styled-components";
const Wrapper = styled.video`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${_ref => {
  let {
    $width
  } = _ref;
  return $width;
}};
  min-width: ${_ref2 => {
  let {
    $width
  } = _ref2;
  return $width;
}};
  max-width: ${_ref3 => {
  let {
    $width
  } = _ref3;
  return $width;
}};
  font-size: ${_ref4 => {
  let {
    $width
  } = _ref4;
  return `calc(${$width} / 3)`;
}};
  font-weight: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.typography.fontWeight.bold;
}};
  line-height: 0.66rem;
  height: ${_ref6 => {
  let {
    $height
  } = _ref6;
  return $height;
}};
  ${_ref7 => {
  let {
    $border,
    theme
  } = _ref7;
  return $border === "rounded" && `border-radius: ${theme.shape.borderRadius.primary}`;
}};
  ${_ref8 => {
  let {
    $border
  } = _ref8;
  return $border === "circled" && `border-radius: 50%`;
}};
  background-color: ${_ref9 => {
  let {
    $color
  } = _ref9;
  return $color;
}};
  ${_ref10 => {
  let {
    $s,
    theme
  } = _ref10;
  return theme.spacing.resolve(theme, $s);
}};

  ${_ref11 => {
  let {
    $shadow,
    $border,
    theme
  } = _ref11;
  return $shadow && css`
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: all 200ms ease-out;
        ${$border === "rounded" && `border-radius: ${theme.shape.borderRadius.primary}`};
        ${$border === "circled" && `border-radius: 50%`};
        box-shadow: ${theme.shadows.large};
      }
    `;
}}
`;
const Video = _ref12 => {
  let {
    src,
    width = "120px",
    height = "120px",
    shadow = false,
    border = "rounded",
    autoPlay = false,
    muted = false,
    color = "#000000",
    s,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $shadow: shadow,
    $s: s,
    $width: width,
    $height: height,
    $color: color,
    $border: border,
    src: src,
    autoPlay: autoPlay,
    muted: muted
  }, rest));
};
export default Video;